import React, { useEffect } from 'react'
import { css } from '@emotion/core'
import { string } from 'prop-types'
import { useTranslation } from 'react-i18next'
import { H3 } from '@fs/zion-ui'
import OrdinanceCard from './OrdinanceCard'
import OrdinanceParser from '../../../../../helpers/ordinance/OrdinanceParser'
import { useOrdinances } from '../../../../../../wcf/global/hooks'

const ordinanceCss = css`
  margin: 10px 0px;
`
const ordinancesWrapper = css`
  margin-inline-start: 8vw;
  margin-top: 25px;
  display: flex;
  flex-direction: column;
`

const Complete = ({ ordinances, t }) => (
  <div css={ordinanceCss}>
    <H3>{t('wcf.person-ordinances.ordinances', 'Ordinances')}</H3>

    {ordinances.map((ordinance) => (
      <OrdinanceCard key={ordinance.key} ord={ordinance} />
    ))}
  </div>
)

export default function PersonOrdinances({ personId }) {
  const [ordinances, setOrdinances] = React.useState([])

  const [ordinancesData] = useOrdinances({ personId })
  const { t } = useTranslation()

  useEffect(() => {
    if (ordinancesData) {
      const parser = new OrdinanceParser({ data: ordinancesData, t })
      const allData = parser.buildOrdinanceList()
      setOrdinances(allData)
    }
  }, [ordinancesData, personId, t])

  return (
    <div css={ordinancesWrapper}>
      <Complete ordinances={ordinances} t={t} />
    </div>
  )
}

PersonOrdinances.propTypes = {
  personId: string,
}
